import { render, staticRenderFns } from "./PageVerifyContact.vue?vue&type=template&id=06b7ab84&scoped=true&"
import script from "./PageVerifyContact.vue?vue&type=script&lang=js&"
export * from "./PageVerifyContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b7ab84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b7ab84')) {
      api.createRecord('06b7ab84', component.options)
    } else {
      api.reload('06b7ab84', component.options)
    }
    module.hot.accept("./PageVerifyContact.vue?vue&type=template&id=06b7ab84&scoped=true&", function () {
      api.rerender('06b7ab84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/verifycontact/PageVerifyContact.vue"
export default component.exports